
declare global {
  interface Window {
    $: any;
    jQuery: any;
  }
}

import { Component, Vue } from "vue-property-decorator";

const $ = require("jquery");
window.$ = $;
window.jQuery = $;
require("air-datepicker");

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue"),
    SortBox: () => import("@/components/SortBox.vue"),
    Selectize: () => import("vue2-selectize"),
    Modal: () => import("@/components/Modal.vue"),
    ExportButton: () => import("@/components/ExportButton.vue")
  }
})
export default class CompaniesSubscritors extends Vue {
  exportApiUrl: string = "subscriptors/exportxls";
  title: string = "";
  company: any = {};
  subscriptor: any = {
    companyId: null,
    can_do_request: "",
    mail_notification: "",
    request_notification: "",
    claim_notification: ""
  };
  selectedSubscriptor: any = {
    id: null,
    firstName: "",
    lastName: "",
    email: "",
    subscriptor: {
      id: null,
      fullname: ""
    }
  }
  usersSubscriptors: any = [];
  companyUserSubscriptors: any = [];
  currentSubscritor: number = 0;
  branches: any = [];
  sBranches: any = [];
  currentSort: Record<string, string> = {
    col: "name",
    dir: "asc",
  };
  selectizeOptions: Record<string, any> = {
    delimiter: ",",
    persist: true,
  };
  selected: any = [];
  error: boolean = false;

  async mounted() {
    const _this: any = this;

    await this.loadCompany();
    await this.loadCompanySubscriptors();
    await this.loadSubscriptors();

    this.subscriptor.companyId = this.$route.params.id;

    this.selected = [];

    this.company.branches.forEach((item: any) => {
      this.selected.push(item.id);
    });

    $(document).on("click", ".item.show-delete-item", function (this: any) {
      var select = $("#branches").selectize();
      var selectSizeControl = select[0].selectize;
      var selectedValue = $(this).attr("data-value");
      select[0].selectize.removeItem(selectedValue);
      select[0].selectize.refreshItems();
      select[0].selectize.refreshOptions();
      $(this).removeClass("show-delete-item");
    });

    $("body").on("mouseenter", ".selectize-input .item", function (this: any) {
      $(this).addClass("show-delete-item");
    });
    $("body").on("mouseleave", ".selectize-input .item", function (this: any) {
      $(this).removeClass("show-delete-item");
    });
  }

  async loadCompany() {
    let response: any = await (this.$root as any)._post(
      `companies/one/${this.$route.params.id}`,
      {
        models: "branches",
      }
    );
    this.company = response.data[0];
    this.title = `Lista Suscriptores de ${this.company.name}`;
  }

  async loadCompanySubscriptors() {
    let response: any = await (this.$root as any)._get(`subscriptors`, {
      companyId: this.$route.params.id,
    });

    this.companyUserSubscriptors = response.data;
  }

  async loadSubscriptors() {
    let response: any = await (this.$root as any)._get(`subscriptors`, {
      excludeCompanyId: this.$route.params.id,
      businessId: this.company.businessId
    });

    this.usersSubscriptors = response.data;
  }

  async associate() {
    try {
      await (this.$root as any)._post(
        `companies/${this.company.id}/subscriptors/${this.selectedSubscriptor.subscriptor.id}`
      );

      this.clear();
      this.loadCompanySubscriptors();
      this.loadSubscriptors();

      (this.$root as any).notify(`El suscriptor ${this.getSubscriptorName(this.selectedSubscriptor)} fue asociado al contrato.`);
    } catch (error) {
      (this.$root as any).notify("No fue posible asociar el suscriptor al contrato. Intente nuevamente.", "error");
    }
  }

  async remove(id: number) {
    try {
      await (this.$root as any)._delete(
        `companies/${this.company.id}/subscriptors/${id}`
      );

      (this.$root as any).notify(`El suscriptor ${this.getSubscriptorName(this.selectedSubscriptor)} fue desasociado del contrato.`);

      this.loadCompanySubscriptors();
      this.loadSubscriptors();
    } catch (error) {
      (this.$root as any).notify("No fue posible desasociar el suscriptor del contrato. Intente nuevamente.", "error");
      return;
    }
  }

  clear() {
    this.selectedSubscriptor.id = null;
  }

  showDeleteModal(id: number) {
    this.currentSubscritor = id;
    (this.$refs.modal as any).show();
  }

  cancel() {
    this.subscriptor = {
      companyId: this.$route.params.id,
      can_do_request: "",
    };
    this.selected = [];
    this.company.branches.forEach((item: any) => {
      this.selected.push(item.id);
    });
  }

  getSubscriptorName(user: any) {
    if (user.subscriptor.fullname == null || user.subscriptor.fullname.trim() === "") {
      return user.firstName + " " + user.lastName;
    } else {
      return user.subscriptor.fullname;
    }
  }

  getNotificationsDescription(subscriptor: any) {
    let notifications: string[] = [];

    if (subscriptor.mail_notification) {
      notifications.push("Siniestros");
    }

    if (subscriptor.request_notification) {
      notifications.push("Solicitudes");
    }

    if (notifications.length === 0) {
      return "-";
    }

    return notifications.join("/");
  }
}
